import { Box, BoxProps, Skeleton, Typography } from '@mui/joy';
import { PropsWithChildren } from 'react';

interface SectionProps extends PropsWithChildren, BoxProps {
	heading?: string | React.ReactNode;
	loading?: boolean;
}
export const Section = ({
	heading,
	children,
	sx,
	loading = false,
	...props
}: SectionProps) => {
	return (
		<Box sx={{ maxWidth: '856px', ...sx }} {...props}>
			{heading && (
				<Typography
					level='chartTitle'
					sx={{ textTransform: 'capitalize', fontWeight: 500 }}
				>
					<Skeleton loading={loading}>{heading}</Skeleton>
				</Typography>
			)}
			{children}
		</Box>
	);
};
